const LINE_SHARE_LINK = "http://line.me/R/msg/text/?"

export const getLineShareLink = (targetUrl: string): string => {
  return `${LINE_SHARE_LINK}${targetUrl}`
}
